import React from "react";
import { useState, useEffect } from "react";
import { Box, Typography, Snackbar } from "@material-ui/core";
import useStyles from "./CheckIn.style";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { checkInList } from "../data/db";
import { MobileAlert } from '../components'
import Cookies from "universal-cookie";
import MobileLoading from "../components/MobileLoading";


const cookies = new Cookies();

function CheckIn({ handleRegularPageClick }) {
const classes = useStyles();

  const [checkInItems, setCheckInItems] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [userId, setUserId] = useState()
  const [userName, setUserName] = useState()
  const [previousCheckIns, setPreviousCheckIns] = useState([])
  const [loading, setLoading]=useState(false)
  const [error, setError] = useState(false);


  const setHandleSwitchToRegularPage = async () => {
    handleRegularPageClick();
    try {
      let response = await fetch(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_USER_ADD_CHECKIN}`,
        {
          method: "post",
          body: new URLSearchParams({
            id: userId,
            letsCheckIn: selectedItems,
          }),
          headers: {
            "X-ACCESS-TOKEN": cookies.get("token"),
          },
        }
      );
      if (!response) return;
      else {
       return;
      }
    } catch (error) {
      console.log(error);
    }

  };

  useEffect(() => {
    setLoading(true)
    const getCheckIns = async () => {
      try {
        let url = new URL(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_USER_GET_CHECKIN}`)

        url.searchParams.append("id", userId);
        let response = await fetch(
          url,
          {
            headers: {
              "X-ACCESS-TOKEN": cookies.get("token"),
            },

          }
        );
        if (!response) return;
        setLoading(false)
        let json = await response.json();
        setPreviousCheckIns(json && json[0].checkin.map((val, i) => val+'.'))
      } catch (error) {
        setLoading(false)
        console.log(error);
      }
    }

    getCheckIns()

  }, [userId])

  useEffect(() => {
    setCheckInItems(checkInList);


    const getUserId = async () => {


      await fetch(
        `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_AUTH}/app/me`,
        {
          headers: {
            "X-ACCESS-TOKEN": cookies.get("token"),
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setUserId(res._id);
          setUserName(res.firstName)
        })
        .catch((error) => {

          console.error("Error fetching user ID:", error);
        });
    };
    getUserId();
  }, [selectedItems]);

  useEffect(() => {
    const settingPreviousCheckins = () => {
    
      const lastItemIndex = previousCheckIns.length - 1;
      if (lastItemIndex >= 0) {
        const lastItem = previousCheckIns[lastItemIndex];
        if (lastItem.endsWith('..')) {
          previousCheckIns[lastItemIndex] = lastItem.slice(0, -1);
        }
      }
      const newSelectedIndex = previousCheckIns.reduce((acc, val) => {
        const index = checkInItems.findIndex((item) => item.item === val);
        if (index !== -1) {
          acc = [...acc, index];
        }
        return acc;
      }, []);

      const newSelectedItems = newSelectedIndex.map((index) => checkInItems[index].item);
      setSelectedItems(newSelectedItems);
      setSelectedIndex(newSelectedIndex);
    }
  
    settingPreviousCheckins();
  }, [previousCheckIns, checkInItems]);


  const handleMessageClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setError(false);
  };

  const handleOnClick = (i) => {
    if (checkInItems[i].id === i) {
      setSelectedIndex([...selectedIndex, i]);
      setSelectedItems([...selectedItems, checkInItems[i].item]);
      if (selectedIndex.includes(i)) {
        let filteredSelectedIndex = selectedIndex.filter((val) => {
          return val !== i;
        });
        setSelectedIndex([...filteredSelectedIndex]);
      } else {
        setSelectedIndex([...selectedIndex, i]);
      }
      if (selectedItems.includes(checkInItems[i].item)) {
        let filteredSelectedItems = selectedItems.filter((val) => {
          return val !== checkInItems[i].item;
        });
        setSelectedItems([...filteredSelectedItems]);
      } else {
        setSelectedItems([...selectedItems, checkInItems[i].item]);
      }
    }
  };
if (loading || userName === undefined) return <MobileLoading />;
  return (
    <Box className={classes.mainContainer}>
      <Typography variant="h1" className={classes.mainHeading}>
        {`Hi ${userName}`}
      </Typography>
      <Typography className={classes.subHeading} variant="h2">
        Happy to see you here, let’s RepLI!
      </Typography>
      <Box>
        <List
          sx={{
            width: "100%",
            marginTop: "10%",
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          {checkInItems.map((val, i) => {
            return (
              <ListItemButton
                onClick={() => handleOnClick(i)}
                sx={{
                  textAlign: "center",
                  color: "#4A618A",
                  transition: "0.1s ease-in",
                  borderRadius: "4px",
                  borderLeft: selectedIndex.includes(i)
                    ? "3px solid #1FA19D"
                    : "3px solid white",
                  borderRight: selectedIndex.includes(i)
                    ? "3px solid #1FA19D"
                    : "3px solid white",
                  backgroundColor: selectedIndex.includes(i)
                    ? "#e2e2e2"
                    : "white",
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                    borderLeft: "3px solid #1FA19D",
                    borderRight: "3px solid #1FA19D",
                    scale: "103%",
                  },
                }}
                key={val.id}
              >
                <ListItemText
                  sx={{ width: "100%", height: "100%" }}
                  primary={val.item}
                />
              </ListItemButton>
            );
          })}
        </List>
      </Box>

      <Snackbar open={error} autoHideDuration={6000} onClose={handleMessageClose}>
        <MobileAlert onClose={handleMessageClose} severity="error">
          {"Please select at least one option"}
        </MobileAlert>
      </Snackbar>


      <button
        className={classes.SubmitBtn}
        onClick={() => {
          if (selectedItems.length === 0) {
            setError(true);
          } else {
            setError(false);
            setHandleSwitchToRegularPage();
          }
        }}
      >
        {"➜"}
      </button>
    </Box>
  );
}

export default CheckIn;
